import React, {useEffect} from 'react';
import {Typography} from '@mui/material';
import AppName from '../../components/AppName';
import Nav from './components/Nav';
import './Home.scss';

export const Home = () => {
  useEffect(() => {
    document.querySelector('.logo.hidden').classList.remove('hidden');
  }, []);

  return (
    <div className={'home'}>
      <div className={'logo hidden'} />
      <Typography variant={'h1'}>
        <AppName raw />
      </Typography>
      <Nav />
    </div>
  );
};
